import React from 'react'

const HrSeperator = () => {
  return (
    <hr className='block mt-4 mb-4 ml-auto mr-auto border border-light-accent2 dark:border-dark-accent'/>
    // <div className='border mt-4 mb-2'/>
  )
}

export default HrSeperator